export default __webpack_public_path__ + "static/media/cluster.cfde2c0f.svg";